<template>
  <div >
    <button class="btn btn-xs btn-danger" v-show="btnConfirm" v-on:click="confirm">削除</button>
    <button class="btn btn-xs btn-danger" v-show="btnDelete" v-on:click="del">完全削除</button>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        btnConfirm: true,
        btnDelete: false
      }
    },
    props: ['message'],
    methods: {
      confirm: function () {
        this.btnConfirm = false
        this.btnDelete = true
      },
      del: function () {
        this.$emit('delete')
      }
    }
  }
</script>




// WEBPACK FOOTER //
// BtnDelete.vue?318c454d